export default {
  categories: {
    shoes: 'Shoes',
    hoodies: 'Hoodies / Sweaters',
    tShirts: 'T-Shirts',
    jackets: 'Jackets',
    pants: 'Pants / Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear / Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    other: 'Other Stuff',
  },
};